/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Vector3, Clock } from 'three';
/**
 * Simple Particles class
 */
export class Particles {
    constructor(numberOfParticles) {
        // General
        this._clock = new Clock(true);
        this._emitterStartSpeed = 0.002;
        // Forces
        this._boundaryPos = [0, 0, 0];
        this._boundarySize = [Math.PI * 2, Number.MAX_VALUE, Number.MAX_VALUE];
        this._maxNumberOfParticles = numberOfParticles;
        this._positions = new Array(numberOfParticles * 3);
        this._velocities = new Array(numberOfParticles * 3);
        this._createStartPositions();
        this._createStartVelocities();
    }
    getPositions() {
        return this._positions;
    }
    update() {
        for (let i = 0; i < this._maxNumberOfParticles * 3; i++) {
            this._positions[i] = this._wrap(this._positions[i] + this._velocities[i], i);
        }
    }
    _wrap(v, i) {
        const p = this._boundaryPos[i % 3];
        const s = this._boundarySize[i % 3];
        const n = v - p;
        let r;
        if (n < 0) {
            r = p + s - (n % s);
        }
        else {
            r = p + (n % s);
        }
        return r;
    }
    _createStartPositions() {
        // TODO : generate from emitter setting
        for (let i = 0; i < this._maxNumberOfParticles; i++) {
            this._positions[i * 3] = Math.random() * Math.PI * 2;
            this._positions[i * 3 + 1] = Math.random() * Math.PI * 2;
            this._positions[i * 3 + 2] = Math.random() * Math.PI * 2;
        }
    }
    _createStartVelocities() {
        // TODO : generate from emitter setting
        for (let i = 0; i < this._maxNumberOfParticles; i++) {
            const v = new Vector3(Math.random() - 0.5, 0, 0)
                .normalize()
                .multiplyScalar(this._emitterStartSpeed);
            this._velocities[i * 3] = v.x;
            this._velocities[i * 3 + 1] = v.y;
            this._velocities[i * 3 + 2] = v.z;
        }
    }
}
//# sourceMappingURL=Particles.js.map